<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="isDraft">
      <ion-button color="primary" [attr.aria-label]="'pages.insert.modal.delete' | translate" (click)="delete()" data-cy="Delete draft">
        {{ 'pages.insert.modal.delete' | translate }}
      </ion-button>
    </ion-buttons>

    <ion-title>{{ 'pages.insert.modal.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <ion-button color="primary" [attr.aria-label]="'pages.insert.modal.cancel' | translate" (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ui-current-cdc [project]="project" [showSuperOperatore]="isSuperOperatoreInProjectTask"></ui-current-cdc>
</ion-header>

<ion-content class="ion-padding">
  <div class="flex flex-column min-height-100">
    <front-end-insert-quote-form
      *ngIf="form"
      [id]="'insert-quote-form'"
      [form]="form"
      [assignees]="assignees"
      [project]="project"
      [canInsertSubtask]="isResponsabile"
      [budgetProjectTasks]="budgetProjectTasks"
      (submitted)="send($event)"
      (submittedWithSubtask)="sendAndApprove($event)"
      (changedProjectTask)="checkIfSuperOperatoreInProjectTask($event)"
      [showProjectTasks]="isAnySuperOperatore"
      #quoteForm
    ></front-end-insert-quote-form>

    <ui-bottom-actions>
      <div class="flex flex-column gap-8">
        <ion-button type="submit" form="insert-quote-form" color="primary" data-cy="Send quote">
          {{
            (project.role === RoleEnum.Responsabile ? 'pages.insert.modal.confirm' : 'pages.insert.modal.confirmForApproval') | translate
          }}
        </ion-button>

        <div class="flex flex-row align-items-center justify-content-center">
          <ion-button (click)="draft(quoteFormComponent.formValue())" fill="clear" size="small" data-cy="Draft quote">
            {{ 'pages.insert.modal.draft' | translate }}
          </ion-button>
        </div>
      </div>
    </ui-bottom-actions>
  </div>
</ion-content>
